import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";

import { GOOGLE_ADS_DOWNLOAD_AUDIO_ID } from "@/constants/googleAds";
import { DOWNLOAD_AUDIO_TYPES } from "@/constants/posthog/downloadAudio";
import { trackAudioDownload } from "@/data/posthog/trackAudioDownload";
import { StemSplitWithAudioNoDates } from "@/types/defs/stemSplit";
import { fireGoogleAdsConversion } from "@/utils/gtag/fireGoogleAdsConversion";

export function DownloadStem({
  stemSplit,
}: {
  stemSplit: StemSplitWithAudioNoDates;
}) {
  const downloadUrl = stemSplit.outputSound.presignedUrlDownload;

  const trackDownload = () => {
    trackAudioDownload({
      audioType: DOWNLOAD_AUDIO_TYPES.STEM_SPLITTER,
      entityId: stemSplit.id,
    });
    fireGoogleAdsConversion({
      conversionLabel: GOOGLE_ADS_DOWNLOAD_AUDIO_ID,
      additionalData: null,
    });
  };

  return (
    <a
      href={downloadUrl}
      download={stemSplit.outputSound.filename}
      className="h-6 w-6"
      onClick={trackDownload}
    >
      <ArrowDownTrayIcon
        data-tooltip-id={`download-stem-tooltip-${downloadUrl}`}
        data-tooltip-content="Download"
        data-tooltip-place="top"
        className="h-6 w-6 stroke-gray-900"
      />
      <Tooltip id={`download-stem-tooltip-${downloadUrl}`} />
    </a>
  );
}
